import React from 'react'
import './Title.css';

function About() {
  return (
    <div id="about">
      <div className='title'>
        <h1>About</h1>
        <hr></hr>
      </div>
      <p>My name is Natalie Gallo and I'm a rising Junior studying Computer Science at CUNY Hunter College.</p>
      <p>I was born and raised in The Bronx, New York. I am 20 years old.</p>
      <p>I am a first generation Latina and I am the first in my family to attend college.</p>
      <p>I like reading, dancing, and having game nights with my friends</p>
      <p><b>Fun Fact: </b>I am an Aries and I have a dog named Aries who is actually a Sagittarius :p </p>
    </div>
  )
}

export default About
